export default {
  execute(input) {
    // verify if input has content
    for(var prop in input) {
      if(input[prop]===undefined || input[prop] === null || input[prop].length===0) {
        var res = {};
        res.err = true;
        res.msg = prop + ' values missing';
        return res;
      }
    }

    var criteria = input['criteria']
    var actions = input['actions']
    var orderByCriterion = input['orderByCriterion']['Name']
    if(criteria === null || actions === null || orderByCriterion === null)
      return false
    //ascendant or descendant
    var direction = input['orderByCriterion']['Direction']
    
    //make a copy of actions
    var results = actions.slice()

    //if the selected criterion is of type number, then transform all its values to numbers
    for(var criterion in criteria)
      if(criteria[criterion]['Name'] == orderByCriterion && criteria[criterion]['type'] == 'Number')
        for(var result in results)
          results[result][criteria[criterion]['Name']] = Number(results[result][criteria[criterion]['Name']]);

    function compareActions(a, b) {
      if(direction == "Ascendant") {
        if(a[orderByCriterion] < b[orderByCriterion])
          return -1;
        if(a[orderByCriterion] > b[orderByCriterion])
          return 1;
        return 0;
      } else if (direction == "Descendant") {
        if(a[orderByCriterion] < b[orderByCriterion])
          return 1;
        if(a[orderByCriterion] > b[orderByCriterion])
          return -1;
        return 0;
      } else
        console.error("invalid direction: this should not happen")
    }

    //sort the new object by
    results.sort(compareActions)

    return results;
  }
}


// WEBPACK FOOTER //
// ./src/services/OrderByService.js